import { FC, useEffect, useState } from "react"
import { RootState } from "../../../../store"
import { connect } from "react-redux"
import { NavigationProps } from "../../../../types"
import { logout } from "../../../../actions/loginActions"
import AdminNavSection from "./AdminNavSection"
import { KLogo } from "kahuna-base-react-components"
import { useNavigate } from "react-router-dom"
import { fetchUserData } from "../../../../actions"
import {
  fetchMissingTrackShareHolderCount,
  fetchReleaseEditAgainSubmitCount,
  fetchUserHasUpdateCount
} from "../../../../actions/adminActions"

const AdminNavigation: FC<NavigationProps> = (props) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!props.missingTrackShareHolderCount) {
      props.fetchMissingTrackShareHolderCount()
    }
    if (!props.releaseEditAgainSubmitCount) {
      props.fetchReleaseEditAgainSubmitCount()
    }
    if (!props.userHasUpdateCount) {
      props.fetchUserHasUpdateCount()
    }
  }, [])

  return (
    <div
      className={"flex flex-col justify-between h-full"}
      style={{
        borderRight: "1px solid #F3F3F3"
      }}
    >
      <div className="flex flex-col grow gap-0" style={{ overflow: "scroll" }}>
        <div
          className="py-2.5 w-11 flex items-center justify-center cursor-pointer"
          onClick={() => {
            navigate("/")
          }}
        >
          <KLogo hoverEnabled width={44} height={44} logoColor="white" />
        </div>
        <AdminNavSection
          user={props.user}
          missingShareHolderCount={props.missingTrackShareHolderCount}
          releaseEditAgainSubmitCount={props.releaseEditAgainSubmitCount}
          userHasUpdateCount={props.userHasUpdateCount}
        />
      </div>

      <div className="flex items-center justify-center">
        {/* <InfoSection />
        <SocialSection />
        <ChangeUserModal
          open={changeUserModalOpen}
          setOpen={setChangeUserModalOpen}
          userMembers={props.user.userMembers}
          fetchUserData={props.fetchUserData}
        />
        <ProfileDropdownMenu
          isAdmin={true}
          setChangeUserModalOpen={setChangeUserModalOpen}
          goBackToAccount={goBackToAccount}
        />*/}
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user,
    missingTrackShareHolderCount: state.admin.missingTrackShareHolderCount,
    releaseEditAgainSubmitCount: state.admin.releaseEditAgainSubmitCount,
    userHasUpdateCount: state.admin.userHasUpdateCount
  }
}

export default connect(mapStateToProps, {
  logout,
  fetchUserData,
  fetchMissingTrackShareHolderCount,
  fetchReleaseEditAgainSubmitCount,
  fetchUserHasUpdateCount
})(AdminNavigation)
